<template>
  <div>
    <div v-for="item in dataSummarizedByDate" :key="item.date">

      <div class="date-title">
        {{ item.date }} {{ '(' + item.task.length + '本)' }}
        <v-btn
          v-on:click="writeToClipboard(item.task)"
          color="indigo lighten-2"
          small>
          <v-icon color="indigo lighten-5">mdi-content-copy</v-icon>
        </v-btn>          
      </div>

      <div class="date-table">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(value, name) in item.task[0]"
                  :key="value + name"
                  v-show="name != 'date' && name != 'place'"
                >
                  {{ name }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="task in item.task" :key="task.id">
                <td
                  v-for="(value, name) in task"
                  :key="name"
                  v-show="name != 'date' && name != 'place'"
                  v-bind:style="name === 'グレード' ? '' : ''"
                >
                  {{ value }}
                </td>
              </tr>
            </tbody>

          </template>
        </v-simple-table>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      storageData : [],
    }
  },
  mounted () {
    this.storageData = JSON.parse(this.getStorageData())
  },
  computed: {
    // データを日毎にまとめる
    dataSummarizedByDate () {
      const dateList = [];
      let uniqueDateList = [];
      const dataSummarizedByDay = [];
      if (!this.storageData) return
      // 日付のみ抽出
      this.storageData.forEach(element => {
        dateList.push(element.date)
      })
      // 重複削除＆最近順にソート
      uniqueDateList = Array.from(new Set(dateList)).reverse();
      // 日付ごとにまとめられたデータの作成
      uniqueDateList.forEach(day => {
        const dayData = {
          date : day,
          task : []
        }
        this.storageData.filter(item => item.date === day).forEach(element => {
          // テーブルに表示しない項目の削除
          // dayData.task.push(_.omit(element, 'id', 'place', 'date'))
          dayData.task.push(_.omit(element, 'id'))
        })
        dataSummarizedByDay.push(dayData)
      })

      return dataSummarizedByDay
    }

},
  methods: {
    ...mapGetters({
      getStorageData: 'task/getStorageData'
    }),
    ...mapMutations({
      syncStorageData: 'task/syncStorageData'
    }),

    // 選択された日の結果をTSV形式にしてコピー
    writeToClipboard(text) {
      // const header = Object.keys(text[0]).join('\t') + "\n";
      // jsonをTSV形式に変換(ヘッダ行はなし)
      const body = text.map(function(d){
          return Object.keys(d).map(function(key) {
              return d[key];
          }).join('\t');
      }).join("\n");

      navigator.clipboard.writeText(body).catch((e) => {
        // netlifyのビルドでエラーを吐かれたので握りつぶす
        // (どこかで対応する)
        // console.error(e)
      })
    },

    // 結果の削除
    deleteResult () {
      localStorage.clear()
      this.storageData = []
      this.$emit('updateTryCount')
    }
  },
}
</script>

<style scoped lang="scss">
@import "colors.scss";

.date-title {
  margin-top: 7px;
  margin-bottom: 5px;
}

.date-table {
  margin-bottom: 25px;
}

table {
  width: auto;
}

thead {
  tr {
    background: $indigo__lighten-5;
  }
}

th, td {
  width: auto !important;
  white-space: nowrap;
  font-size: 12px !important;
}

// tr:nth-child(odd) td {
//   background: $indigo__lighten-5;
// }

tr:hover td {
  background-color: rgb(238, 238, 238);
}
</style>